module.exports = __webpack_public_path__ + "img/techcast-grafik_event-produktion.5c04c11.png";